import { JSX, Suspense, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { ROUTES } from "@/config/routes.ts";
import { useGetContentDetailPage } from "@/hooks/api/content.hooks.ts";
import { cn } from "@/utils/cn.ts";

import SectionSkeleton from "../helpers/Section/Section.skeleton.tsx";
import IconChevronRight from "../icons/IconChevronRight.tsx";
import DetailEpisodesSlides from "./DetailEpisodesSlides.tsx";

const DetailEpisodes = (): JSX.Element => {
  const { t } = useTranslation();

  const { id } = useParams() as { id: string };
  const { data } = useGetContentDetailPage(+id);
  const [currentSeason, setCurrentSeason] = useState<number>(data?.content.seasons ? data?.content.seasons[0].id : 0);

  if (!data) return <></>;
  const content = data.content;
  if (!content.is_serial) return <></>;

  return (
    <section className={"mt-8  max-lg:mt-3 max-lg:rounded-[1.25rem] max-md:mt-0"}>
      <div className={"flex items-center gap-5 max-lg:flex-col max-lg:items-start max-lg:gap-2 "}>
        <Link
          to={ROUTES.DETAIL.EPISODES.replace(":id", String(id))}
          className={
            "group flex items-center gap-2 text-[2rem]/normal font-semibold transition-all hover:text-primary max-md:text-lg"
          }
        >
          {t("General.season", { count: 0 })}{" "}
          <IconChevronRight className="size-8 stroke-on-surface-variant transition-all group-hover:stroke-primary max-md:size-6" />
        </Link>
        <ul className={"flex items-center gap-4 max-lg:gap-2"}>
          {content.seasons &&
            content.seasons.map((season) => (
              <li key={season.id}>
                <button
                  type={"button"}
                  aria-label={`${season.season_numb}`}
                  onClick={() => setCurrentSeason(season.id)}
                  className={cn(
                    "size-14 rounded-full bg-[#FFFFFF14] text-2xl/none font-medium transition-colors hover:bg-[#FFFFFF4D] max-xl:size-10 max-xl:text-base/none",
                    {
                      "bg-orange-1 hover:bg-orange-3": currentSeason === season.id,
                    },
                  )}
                >
                  {season.season_numb}
                </button>
              </li>
            ))}
        </ul>
      </div>
      <Suspense fallback={<SectionSkeleton type={"content"} title={""} link={ROUTES.CHANNELS.MAIN} className="mt-6" />}>
        <DetailEpisodesSlides contentId={+id} currentSeason={currentSeason} />
      </Suspense>
    </section>
  );
};

export default DetailEpisodes;
